// Common constants, like tokens, etc.
export const PG_REST_TOKEN=''
export const PG_REST_URL='/api'

export const IMAGES_PATH = 'images/catalog';

export const HIDE_ALERT = 'HIDE_ALERT'
export const SHOW_ALERT = 'SHOW_ALERT'

export const SEARCH_CHANGE      = 'SEARCH_CHANGE'
export const SEARCH_LOADDATA    = 'SEARCH_LOADDATA'

export const BADGE_RED  = 'red'
export const BADGE_BLUE = 'blue'

export const GOOGLE_CLIENT_ID = '194842906988-ghhidnru7me4vh1i6i1i54c08vpps74o.apps.googleusercontent.com'
export const RECAPTCHA_SITE_KEY = '6Lcgl0gtAAAAAGKPkSpwMNVy7qqwTYr5DpAnJNC_'
